import { takeLatest, call, put } from 'redux-saga/effects';

import { actions as snackbarActions } from 'redux/snackbar';
import * as api from 'http/admin/customFields';

import { actions } from './index';

function* getCustomFields() {
  try {
    const result = yield call(api.getCustomFields);

    yield put(actions.getCustomFieldsSuccess(result));
  } catch (error) {
    yield put(actions.getCustomFieldsFailure(error));
    yield put(snackbarActions.showSnackbar({ data: { type: 'error', message: error.message } }));
  }
}

export default function* sagas() {
  yield takeLatest(actions.getCustomFields, getCustomFields);
}
